import LoaderForButton from "./LoaderForButton";

export default LoaderForButton;
